var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error_message_container"},[_c('span',{staticClass:"error_text"},[_vm._v("\n    加载失败，请保存页面再刷新\n  ")])])}]

export { render, staticRenderFns }